export default __webpack_public_path__ + "static/media/chevron_left-blue.ce45bb89.svg";